import { render, staticRenderFns } from "./ChannelScriptTemp.vue?vue&type=template&id=247f4948&"
import script from "./ChannelScriptTemp.vue?vue&type=script&lang=ts&"
export * from "./ChannelScriptTemp.vue?vue&type=script&lang=ts&"
import style0 from "./ChannelScriptTemp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports